import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

import DemoModeSvc from "../../services/demoModeSvc";

export const DemoPage: React.FunctionComponent = () => {
  const demo = DemoModeSvc.current;

  const history = useHistory();

  useEffect(() => {
    if (!demo.isDemoModeOn) {
      demo.toggleDemo();
    }
    history.push("/");
  }, [demo, history]);

  // This page does not actually render anything, it just redirects to the home page
  // after prompting the user to turn on demo mode.
  return <div></div>;
};
